import {getUnitList} from "@/api/Unit"

export default {
  addUnit({
    commit
  }, unit) {
    return new Promise((resolve, reject) => {
      commit('ADD_UNIT', unit)
      resolve()
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchDataListItemsUnit({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      getUnitList(payload)
        .then((response) => {
          if(response.status === 200){
          commit('SET_UNIT', response.data);
          resolve(response);
          }else{
            reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
          }
          
        })
        .catch(error => {
          reject(new Error("Sunucu Bağlantısı Başarısız !"));
        })
    })
  },
  updateUnit({
    commit
  }, unit) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_UNIT', unit)
      resolve()
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeUnit({
    commit
  }, unitId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_UNIT', unitId)
      resolve();
    })
  }
};